import { envType } from '../../../common/types';
import { getEnvType } from '../../../utils';

export const getManageProfileLink = (email: string) => {
	return getEnvType() === envType.PROD
		? `https://id.atlassian.com/login?application=dev-agents&continue=${encodeURIComponent(
				'https://id.atlassian.com/manage-profile',
			)}&prompt=none&login_hint=${encodeURIComponent(email)}`
		: `https://id.stg.internal.atlassian.com/login?application=dev-agents&continue=${encodeURIComponent(
				'https://id.stg.internal.atlassian.com/manage-profile',
			)}&prompt=none&login_hint=${encodeURIComponent(email)}`;
};
